import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, DestroyRef, inject} from '@angular/core';
import {map} from 'rxjs/operators';
import {Assets} from '../../../oauth/models/headless-cms/Assets';
import {LoginPageResponse} from '../../../oauth/models/headless-cms/login-page-response';
import {LoginAds} from '../../../oauth/models/headless-cms/LoginAds';
import {LoginService} from '../../../core/services/login.service';
import {UtilsService} from '../../../core/services/utils';
import {LoginPageApiService} from '../../../core/services/login-page-api.service';
import { FormsModule } from '@angular/forms';
import { NgxHmCarouselModule } from 'ngx-hm-carousel';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'info-slider',
    templateUrl: 'info-slider.component.html',
    styleUrls: ['info-slider.component.scss'],
    imports: [NgIf, NgClass, NgxHmCarouselModule, FormsModule, NgFor]
})
export class InfoSliderComponent implements OnChanges, AfterViewInit, OnInit {

  @Input()
  public loginChallenge;

  @Input()
  public domain;

  public slideInterval = 5000;
  public assets: Assets[] = [];
  public loginResponse: LoginPageResponse;
  public messageProperties;
  public infinite = true;
  public autoplay = true;
  public currentIndex = 0;
  public configuredLoginTitle = '';
  public configuredLoginSubtitle = '';
  public actualImage: string;

  private defaultLoginTitle = 'Welcome to greytHR';
  private defaultLoginSubTitle = 'Streamline. Save Time. Better Clime';

  private readonly imagePrefix = 'gt-login-state-';
  private changeBackgroundCounter = 1;
  private changeBackgroundCounterMax = 2;
  private destroyRef = inject(DestroyRef);

  constructor(private _loginService: LoginService,
              private _utils: UtilsService,
              private _loginPageApiService: LoginPageApiService) {
  }

  public ngOnInit() {
    this.changeBackgroundCounter = Math.floor(
      Math.random() * (this.changeBackgroundCounterMax) + 1
    );
    this.actualImage = this.imagePrefix + this.changeBackgroundCounter;
  }

  public ngAfterViewInit() {
    this.loadLoginPageRes();
  }

  public loadAssets() {
    this._loginService.getLoginAds(this.loginChallenge, this.domain)
      .pipe(
        map((res: LoginAds[]) => res.map(({data}) => data)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((data) => {
        this.assets = data;
      });
  }

  public getImageSrc({image}): string {
    if (this._utils.isEmpty(image)) {
      return;
    }
    const [src] = image;
    return this._loginService.getAsset(src);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (!this._utils.isEmpty(changes?.loginChallenge?.currentValue) || !this._utils.isEmpty(changes?.domain?.currentValue)) {
      this.loadLoginPageRes();
    }
  }

  public navigateToLink(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  private loadLoginPageRes() {
    this._loginPageApiService.getLoginPage()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.loginResponse = res;
        this.messageProperties = this.preapareProperties(this.loginResponse.messageProperties);
        this.configuredLoginTitle = this.messageProperties.login_title ? this.messageProperties.login_title : this.defaultLoginTitle;
        this.configuredLoginSubtitle = this.messageProperties.login_subtitle
          ? this.messageProperties.login_subtitle
          : this.defaultLoginSubTitle;
        if (!this.loginResponse.disableLoginPageCards) {
          this.loadAssets();
        }
      }, (error) => {
        console.error('error occurred while loading login page response ', error);
        this.configuredLoginTitle = this.defaultLoginTitle;
        this.configuredLoginSubtitle = this.defaultLoginSubTitle;
      });
  }

  private preapareProperties(properties) {
    return properties.reduce((model, obj) => {
      const {key} = obj;
      const replacementKey = key.replace('.', '_');
      model[replacementKey] = obj.value;
      return {...model};
    }, {});
  }
}
